// @ts-nocheck
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, SendTracking } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const SendUetTracking = createChainHandler("SendUetTracking", chain, props => {
    if (typeof window === "undefined" || !window.uetq) {
        return;
    }

    const session = getSession(props.getState());
    const updatedCart = {
        ...props.cartToUpdate!,
        orderNumber: props.apiResult!.cart.orderNumber,
    };
    const revenue = updatedCart.orderGrandTotal;
    const currency = session.currency?.currencyCode ?? "CAD";

    window.uetq.push("event", "", {
        revenue_value: revenue,
        currency,
    });

    // Test to be removed
    console.log({
        revenue_value: revenue,
        currency,
    });
});

addToChainAfter(chain, SendTracking, SendUetTracking);
